var cacheVersion = '5';		// controls version for cookies and cache data in store selector 
var geoCookieKey = "user-geo-"+ cacheVersion;
var ip_data_key = '5ef84b996caa8ec9a99bac72ce2d8f7f20a873a45357648a47f64135';
var ip_data_url = 'https://api.ipdata.co/?api-key=' + ip_data_key;
var geoCookieDuration = 365;
var defaultStoreCookieDuration = 365;
var storeCookieKey = "selected-Coast-store" + cacheVersion;
var locationsCacheVersion = '5';

var store_data_version = 3;
var store_data_key = "store_data";
var store_locations_key = "store_locations";

function writeGeoCookie(data){
  var cookieValue = '{"pcode":"' + data.postal  +'", "lat":'+ data.latitude +'", "lon":'+ data.longitude +'", "region_code":'+ data.region_code +'", "country_code":'+ data.country_code +'}';           
  WriteCookie(geoCookieKey, cookieValue, geoCookieDuration);
}
          
/** selected-Coast-store cookie --- Automatically read customer location and save it in format as {"province":"BC", "storeid":111, "region":"Vancouver"} **/

function SetGeoData(){
  var geocookie =  readCookie(geoCookieKey);
  var storecookie = readCookie(storeCookieKey); 
  if (geocookie == null)
  {
    $.getJSON(ip_data_url, function(data) {
      try{
           writeGeoCookie(data);
           if (storecookie == null)
           {
                var store_locations_url = getStoreLocationsJson();
           		$.getJSON(store_locations_url, function(storedata) {
					var closestStore = GetClosestStore(data.latitude, data.longitude, storedata);
                  	if (closestStore != null)
                    {   
                        WriteStoreCookie(closestStore.province, closestStore.id, closestStore.region, defaultStoreCookieDuration);
                      	location.reload(true);
                    }
                  	
               });
           }

      }
      catch (err){	
      	// if there is a big error writte a default geo cookie with 1 day expiration, the user will be prompt to select a store         
        WriteCookie(geoCookieKey, '{}', 1);
        location.reload(true);
      }
  	  })
     .fail(function() {
      		WriteCookie(geoCookieKey, '{}', 1); 
    		location.reload(true);
    	})
     ;
  }
}

async function setLocationCookieFromGoogleRegionId(store) {
  var geocookie = readCookie(geoCookieKey);
  var storecookie = readCookie(storeCookieKey);
  if (geocookie) {
    //if geo cookie is present
    if (storecookie) {
    //if store location cookie is present
      const storecookieObj = JSON.parse(storecookie);
      if (!(storecookieObj.province === store.province && storecookieObj.storeid === store.id && storecookieObj.region === store.region)) {
        WriteStoreCookie(store.province, store.id, store.region, defaultStoreCookieDuration);   
      }
      location.reload(true);
    }
  } else {
    //if geo cookie is not present
    $.getJSON(ip_data_url, function(data) {
        try {
          writeGeoCookie(data);

          if (storecookie == null) {
          //if store location cookie is not present
            WriteStoreCookie(store.province, store.id, store.region, defaultStoreCookieDuration);
            location.reload(true);
          }
        } catch (err) {
          // if there is a big error writte a default geo cookie with 1 day expiration, the user will be prompt to select a store         
          WriteCookie(geoCookieKey, '{}', 1);
          location.reload(true);
        }
      })
      .fail(function() {
        WriteCookie(geoCookieKey, '{}', 1);
        location.reload(true);
      });
  }
}
